import React, { PureComponent } from 'react';
import logo from 'resource/img/logo.png';
import Button from 'component/button.component';
import LoginModal from './login.modal.component';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import OpacityModal from 'component/opacity.modal.component';
import NewsletterModal from 'component/newsletter.modal.component';
import ProfileMenu from './profile.menu.component';

class Header extends PureComponent {
  state = {
    loginModal: null,
  };

  hasUserCalendarToken() {
    if (this.props.user.calendar_token) {
      return `/novo-recorte`;
    }
    return `/sobre-recorte`;
  }

  render() {
    const {
      isUserLoggedIn,
      user,
      userLogin,
      resetPassword,
      isAdmin,
    } = this.props;
    const { loginModal } = this.state;

    return (
      <div
        className="header-menu flex-row justify-center align-stretch"
        style={{
          height: 70,
          position: 'fixed',
          top: 0,
          width: '100%',
          zIndex: 10,
        }}
      >
        <div className="content-center flex-row justify-between align-stretch">
          <div className="flex-row flex-1 align-stretch">
            <RouterLink
              className="header-menu-logo flex-row justify-start align-center"
              to="/"
            >
              <img className="header-menu-logo-img" src={logo} alt="logo" />
              <p className="header-menu-logo-text">Juslabore</p>
            </RouterLink>
            <div className="header-menu-center-content flex-column flex-1 justify-center align-start">
              <div className="flex-row align-center justify-center">
                <Button
                  className="header-button"
                  onClick={() => this.props.history.push(`/`)}
                  text="Home"
                  style={{ width: 65 }}
                />
                <Button
                  className="header-button"
                  onClick={() => this.props.history.push(`/proposito`)}
                  text="Propósito"
                  style={{ width: 90 }}
                />
                <Button
                  className="header-button"
                  onClick={() => this.props.history.push(`/contato`)}
                  text="Contato"
                  style={{ width: 80 }}
                />
                {isUserLoggedIn && (
                  <>
                    <Button
                      className="header-button"
                      onClick={() =>
                        this.props.history.push(`/acompanhar-agenda`)
                      }
                      text="Acompanhar Agenda"
                      style={{ width: 175 }}
                    />
                    <Button
                      className="header-button"
                      onClick={() =>
                        this.props.history.push(this.hasUserCalendarToken())
                      }
                      text="Novo Recorte"
                    />
                  </>
                )}
                <Button
                  className="header-button"
                  onClick={() => this.props.history.push(`/sobre-recorte`)}
                  text="Sobre o Recorte"
                />
              </div>
            </div>
          </div>
          {isUserLoggedIn ? (
            <div className="flex-row align-center justify-center">
              <NewsletterModal
                onOkBtn={this.props.subscribeNewsletter}
                user={user}
              />

              <Button
                onClick={() => this.props.history.push(`/admin`)}
                text="ADMIN"
                style={{ border: '2px solid #FFF', marginRight: 10 }}
              />

              <ProfileMenu
                className="header-menu-user-logged-in component-focus flex-row align-center
                  justify-center self-align-center self-justify-center"
                user={user}
                history={this.props.history}
              ></ProfileMenu>
            </div>
          ) : (
            <div
              className="flex-row justify-start align-center "
              style={{ paddingTop: 10 }}
            >
              <NewsletterModal
                onOkBtn={this.props.subscribeNewsletter}
                user={user}
              />
              <Button
                onClick={() => this.props.history.push(`/acesso`)}
                text="Entrar"
                style={{ backgroundColor: '#185335', width: 115 }}
              />
            </div>
          )}
        </div>
        <OpacityModal modalRef={ref => this.setState({ loginModal: ref })}>
          <LoginModal
            userLogin={userLogin}
            resetPassword={resetPassword}
            modalRef={loginModal}
          />
        </OpacityModal>
      </div>
    );
  }
}

export default withRouter(Header);
